/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Plate_NumberInputs */

const vi_vehicle_plate_number = /** @type {(inputs: Vehicle_Plate_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biển số`)
};

/**

* @param {Vehicle_Plate_NumberInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_plate_number = /** @type {((inputs?: Vehicle_Plate_NumberInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Plate_NumberInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_plate_number(inputs)
});